import React from 'react';
import { Container, Alert } from 'react-bootstrap';

const RegistrationSuccess = () => {
    return (
        <Container className="mt-5" style={{ marginLeft: 'auto', marginRight: 'auto', maxWidth: '600px' }}>
            <Alert variant="success">
                <Alert.Heading>You've Registered Successfully!</Alert.Heading>
                <p>
                    Thank you for registering. You will receive an email once your account has been activated.
                </p>
            </Alert>
        </Container>
    );
};

export default RegistrationSuccess;
